
import { Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

export default class Header extends Vue {
  @Prop() labelHtml?: string
}
